import React, { Fragment, useState } from 'react';
import { Card, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import Breadcrumb from '../../../layout/breadcrumb';
import { TabSpecimens, TabProvenancesSpecimen, TabOriginSpecimen } from '../../../constant';
import { IndexSpecimen } from '../../specimens/IndexSpecimen';
import { IndexSpecimenProvenances } from '../../specimenProvenances/IndexSpecimenProvenances';
import { IndexSpecimeOrigins } from '../../specimenOrigins/IndexSpecimeOrigins';
import { TabMenu } from 'primereact/tabmenu';


export const IndexSpecimens = (props) => {

    const [activeTab, setActiveTab] = useState("1");

    const toggleTab = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }
    
    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        { label: TabSpecimens },
        { label: TabProvenancesSpecimen }
    ];


    return (
        <Fragment>
            {/* <Breadcrumb parent="Configuraciones" title="Especímenes" /> */}
            <Container fluid={true} className='container-global-zoom'>
                <Row>
                    <Col md="12">
                        <Card>
                                <TabMenu 
                                    model={items} 
                                    activeIndex={activeIndex} 
                                    onTabChange={(e) => setActiveIndex(e.index)}
                                    className="custom-tabmenu-blue-report"

                                />
                        

                            {activeIndex === 0 && (
                                <IndexSpecimen
                                    {...{ ...props, activeTab }}
                                />

                            )}

                            {activeIndex === 1 && (
                                <IndexSpecimenProvenances
                                    {...{ ...props, activeTab }}
                                />
                            )}
                        
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
